import { getDomainLanguage } from '../utils/browser';

export const DE = 'de';
export const NL = 'nl';

export const BROWSER_LANGUAGE = navigator.language || navigator.userLanguage;
export const DOMAIN_LANGUAGE = getDomainLanguage() || DE;
